import { render, staticRenderFns } from "./instagram-icon.vue?vue&type=template&id=70686401&functional=true&"
import script from "./instagram-icon.vue?vue&type=script&lang=js&"
export * from "./instagram-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports